<template>
  <transition
    v-on:after-enter="afterEnter"
    v-on:leave="leave"
    v-bind:css="false"
  >
    <section v-show="isModalOpen" class="modal" :class="{ 'is-enter': isOpen }">
      <button
        class="modal__close"
        :class="{ 'is-enter': isOpen }"
        @click="closeModal"
      >
        <svg viewBox="0 0 73 68" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.5 68L11.5 0H73.6229L74 57L0.5 68Z" fill="white" />
          <line
            x1="25.5548"
            y1="18.9645"
            x2="50.6739"
            y2="41.8801"
            stroke="#E40718"
            stroke-width="2"
          />
          <line
            x1="33.7093"
            y1="34.7049"
            x2="24.2686"
            y2="44.2051"
            stroke="#E40718"
            stroke-width="2"
          />
          <line
            x1="50.726"
            y1="18.1875"
            x2="41.726"
            y2="27.6877"
            stroke="#E40718"
            stroke-width="2"
          />
        </svg>
      </button>
      <div class="movie" :class="{ 'is-enter': isOpen }">
        <video
          ref="movie"
          :poster="require(`@/assets/movie/${posterImage}`)"
          preload="none"
          controls
        >
          <source :src="require(`@/assets/movie/${movieFileName}`)" />
        </video>
      </div>
    </section>
  </transition>
</template>

<script>
import { wait } from '@/modules/utils'
export default {
  props: {
    isModalOpen: {
      type: Boolean,
      default: false
    },

    closeModal: {
      type: Function
    },
    posterImage: {
      type: String
    },
    movieFileName: {
      type: String
    }
  },
  data() {
    return {
      isOpen: false
    }
  },

  mounted() {},

  methods: {
    async afterEnter() {
      const { isMobile } = this.$store.state

      if (window.lmS) window.lmS.stop()
      await wait(150)
      this.$nextTick(() => {
        this.isOpen = true
      })

      await wait(1200)

      if (!isMobile) {
        this.$refs.movie.play()
      }
    },

    async leave(el, done) {
      this.$refs.movie.pause()
      this.isOpen = false
      await wait(1600)
      this.$refs.movie.currentTime = 0
      if (window.lmS) window.lmS.start()
      done()
    }
  }
}
</script>

<style lang="scss" scoped>
.modal {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  min-height: calc(var(--vh, 1vh) * 100);
  z-index: 999;

  @media screen and (max-width: $breakpoint-mobile) {
    position: fixed;
  }

  &:before {
    position: absolute;
    top: 0;
    left: 0;
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    background: var(--main-color);
    transform: translate(-120%, 0) skewX(16deg);
    transition: transform 0.65s 0.65s cubic-bezier(0.4, 0, 0.1, 1);
    z-index: -9;
  }

  &.is-enter {
    &:before {
      transform: translate(0%, 0) skewX(0deg);
      transition: transform 0.65s cubic-bezier(0.4, 0, 0.1, 1);
    }
  }

  &__close {
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    position: absolute;
    top: 0;
    right: 0;
    width: 10rem;
    height: 10rem;
    outline: none;
    transform: translate(100%, -100%) skewX(16deg);
    transition: transform 0.35s 1s cubic-bezier(0.4, 0, 0.1, 1);
    @media screen and (max-width: $breakpoint-mobile) {
      width: 8rem;
      height: 8rem;
    }
    svg {
      width: 100%;
      height: 108%;
    }

    &.is-enter {
      transform: translate(0%, 0%) skewX(0deg);
    }
  }

  .movie {
    position: relative;
    width: 120rem;
    height: 68rem;
    overflow: hidden;
    opacity: 0;
    transform: scale(0.95);
    transition: transform 0.34s cubic-bezier(0.4, 0, 0.1, 1),
      opacity 0.3s 0.34s cubic-bezier(0.4, 0, 0.1, 1);

    @media screen and (max-width: $breakpoint-mobile) {
      width: 100%;
      height: auto;
    }

    &:before {
      position: absolute;
      top: 0;
      left: 0;
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      background: #fff;
      transform: translate(0%, 0) skewX(0deg);
      transition: transform 0.34s cubic-bezier(0.4, 0, 0.1, 1);
      z-index: 9;
    }

    &.is-enter {
      opacity: 1;
      transform: scale(1);
      transition: transform 0.34s 0.9s cubic-bezier(0.4, 0, 0.1, 1),
        opacity 0.5s 0.65s cubic-bezier(0.4, 0, 0.1, 1);

      &:before {
        transform: translate(120%, 0) skewX(-16deg);
        transition: transform 0.34s 1.2s cubic-bezier(0.4, 0, 0.1, 1);
      }
    }

    video {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
